module.exports = __webpack_public_path__ + "img/provider_AWS.57763618.svg";